<template>
    <b-card
        no-body
        border-variant="info"
        style="max-width: 20rem;"
        img-src="../assets/logo.jpg"
        img-alt="Image"
        img-top
        class="mg-card"
    >
    <template #header>
      <h4 class="mb-0 text-center">Vessels Info</h4>
    </template>

    <b-list-group flush>
      <b-list-group-item><span class="font-weight-bold">Name: </span>{{vessel.name}}</b-list-group-item>
      <b-list-group-item><span class="font-weight-bold">Loa:</span> {{vessel.loa}}</b-list-group-item>
      <b-list-group-item><span class="font-weight-bold">Year:</span> {{vessel.year}}</b-list-group-item>
      <b-list-group-item><span class="font-weight-bold">Marina:</span> {{vessel.marina}}</b-list-group-item>
      <b-list-group-item><span class="font-weight-bold">Slip:</span> {{vessel.slip}}</b-list-group-item>
    </b-list-group>   
  </b-card>
</template>

<script>
export default {
    props: {
        vessel: {
            type: Object,
            required: true
        }
    },

    data() {
        return {}
    },   

}
</script>
